import { createContext, useContext, useState } from 'react';

const defaultUser = { email: "", password: ""};

type UserContextType = { email: string, password: string };

const initialUserContext = {
  user: defaultUser,
  setUser: (state: UserContextType) => {}
};

const UserContext = createContext(initialUserContext);

export const useUser = () => {
  const {user, setUser} = useContext(UserContext);

  const updateEmail = (email: string) => setUser({...user, email});

  return {
    user,
    setUser,
    updateEmail,
  };
};

const UserProvider = (props: { children: React.ReactNode }) => {
  const [user, setUser] = useState(defaultUser);

  return <UserContext.Provider value={{ user, setUser }} {...props} />;
};

export default UserProvider;
